import { Size } from '@view-model/models/common/basic';
import { ModelLayout } from '@view-model/models/sticky/layout';

const MaxWidth = ModelLayout.GridSize * 8;
const MaxHeight = ModelLayout.GridSize * 6;

export const fitImageSize = (naturalWidth: number, naturalHeight: number, fallback: Size): Size => {
  if (!(naturalWidth > 0) || !(naturalHeight > 0)) return fallback;

  const scale = Math.min(1, MaxWidth / naturalWidth, MaxHeight / naturalHeight);
  return new Size(Math.max(1, Math.round(naturalWidth * scale)), Math.max(1, Math.round(naturalHeight * scale)));
};

export type ResizeCorner = 'left-top' | 'right-top' | 'left-bottom' | 'right-bottom';

const MinSide = ModelLayout.GridSize;

export const resizeKeepingAspectRatio = (
  size: Size,
  corner: ResizeCorner,
  draggedWidth: number,
  draggedHeight: number
): { size: Size; positionDelta: { dx: number; dy: number } } => {
  const widthScale = draggedWidth / size.width;
  const heightScale = draggedHeight / size.height;
  const draggedScale = Math.abs(widthScale - 1) >= Math.abs(heightScale - 1) ? widthScale : heightScale;
  const minScale = Math.min(1, MinSide / Math.min(size.width, size.height));
  const scale = Math.max(draggedScale, minScale);
  const resized = new Size(Math.round(size.width * scale), Math.round(size.height * scale));

  return {
    size: resized,
    positionDelta: {
      dx: corner.startsWith('left') ? size.width - resized.width : 0,
      dy: corner.endsWith('top') ? size.height - resized.height : 0,
    },
  };
};
